import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ApiError } from '@/lib/api/client';
import { createUser, fetchAdminUsers, updateUser } from '@/services/adminService';
import type { AdminUser, NewUser } from '@/types/api';

const KEY = ['admin', 'users'] as const;

export function useAdminUsers() {
  return useQuery<{ items: AdminUser[] }, ApiError>({
    queryKey: KEY,
    queryFn: fetchAdminUsers,
  });
}

export function useAddUser() {
  const queryClient = useQueryClient();
  return useMutation<AdminUser, ApiError, NewUser>({
    mutationFn: createUser,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateUser() {
  const queryClient = useQueryClient();
  return useMutation<AdminUser, ApiError, { id: string; changes: Partial<AdminUser> }>({
    mutationFn: ({ id, changes }) => updateUser(id, changes),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}
